import { SVGAttributes } from 'react';

export default function Eye(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M12 17C14.7095 16.9972 17.1317 15.3962 18.7405 12.8821C19.0865 12.3414 19.0865 11.6588 18.7405 11.1181C17.1317 8.60388 14.7095 7.00284 12 7C9.29051 7.00284 6.8683 8.60388 5.25948 11.1181C4.9135 11.6588 4.91351 12.3414 5.25949 12.8821C6.86831 15.3962 9.29052 16.9972 12 17Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8955 13.1046 10 12 10C10.8954 10 10 10.8955 10 12C10 13.1046 10.8954 14 12 14Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
}
